import React from "react";
import {Hidden} from "@unibuddy/patron";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";

import {SHOW_HAMBURGER_MENU, NEXT_BEST_ACTIONS_FLAG} from "shared/constants";

import {usePage} from "../../PageProvider/PageContext";
import {WIDGET_PAGE} from "../../PageProvider/PageTitles";
import {NEXT_BEST_ACTIONS_FLAG_DEFAULT} from "../../NextBestActions/NextBestActions";
import HeaderTabs from "../../HeaderBar/containers/HeaderTabs/HeaderTabs";
import MobileMenu from "../components/MobileMenu/MobileMenu";
import {useUser} from "../../User/useUser";

const nextBestActionsHiddenPaths = new Set([
    WIDGET_PAGE.WIDGET_DECISION_STAGE,
    WIDGET_PAGE.WIDGET_RECOMMENDATIONS,
    WIDGET_PAGE.WIDGET_NOT_INTERESTED,
    WIDGET_PAGE.WIDGET_SIGNUP,
    WIDGET_PAGE.WIDGET_LOG_IN,
    WIDGET_PAGE.WIDGET_LOG_OUT,
    WIDGET_PAGE.UNKNOWN,
]);

const Navigation: React.FC<any> = (props) => {
    const user = useUser();
    const {page} = usePage();
    const isHamburgerMenuEnabled = useBooleanFeatureFlag(
        SHOW_HAMBURGER_MENU.key,
        SHOW_HAMBURGER_MENU.value,
    );
    const showNextBestActions = useBooleanFeatureFlag(
        NEXT_BEST_ACTIONS_FLAG,
        NEXT_BEST_ACTIONS_FLAG_DEFAULT,
    );

    if (isHamburgerMenuEnabled) {
        return (
            <>
                <Hidden above="mobile">
                    <MobileMenu
                        {...props}
                        showNba={
                            showNextBestActions && user && !nextBestActionsHiddenPaths.has(page)
                        }
                    />
                </Hidden>
                <Hidden below="tablet">
                    <HeaderTabs primaryApp={props.primaryApp} {...props} />
                </Hidden>
            </>
        );
    }

    return <HeaderTabs primaryApp={props.primaryApp} {...props} />;
};

export default Navigation;
